import { Card, RewardsSummarySection, Section } from '@/components';
import YieldBearingAssetsList, {
  InformationAmount,
} from '@/components/organisms/YieldBearingAssetsList/YieldBearingAssetsList';
import { useWalletsContext } from '@/components/providers/postauth/UserWalletsProvider';
import { useYieldBearingAssets } from '@/components/providers/postauth/YieldBearingAssetsProvider';
import APP_CONFIG from '@/config/app';
import { ALL_YIELD_BEARING_ASSETS_CARD } from '@/utils/strings';
import { FC } from 'react';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const { MAIN_GAP } = APP_CONFIG.STYLES;
const spacingConfig = `gap${MAIN_GAP}`;
const AllYieldBearingAssetsCard: FC<{ className?: string }> = ({
  className,
}) => {
  const { loading } = useYieldBearingAssets();
  const {
    formattedTotalPortfolioRewardsValueInUsd,
    underlyingYieldBearingAssetsTvlWeightedReturn,
    underlyingYieldBearingAssetsTotalMarketCap,
    hasAssetsDeployedInEarn,
  } = useWalletsContext();
  return (
    <Card className={className}>
      <Card.Header
        title={ALL_YIELD_BEARING_ASSETS_CARD.HEADER}
        loading={loading}
      />
      <Card.Body>
        <div
          className={`flex flex-col ${spacingConfig} ${borderClassToVisualizeElementsAndSpacing}`}
        >
          {hasAssetsDeployedInEarn() && (
            <RewardsSummarySection
              formattedTotalRewardsValueInUsd={
                formattedTotalPortfolioRewardsValueInUsd
              }
              blendedReturn={underlyingYieldBearingAssetsTvlWeightedReturn}
              blendedMarketCap={underlyingYieldBearingAssetsTotalMarketCap}
              showCondensedInformation={false}
              isFullBleed
              isBackgroundTransparent
              showHeader={false}
            />
          )}
          <Section
            headerTitle="All Earn Strategies"
            body={
              <YieldBearingAssetsList
                filters={{
                  limit:
                    APP_CONFIG.ALL_YIELD_BEARING_ASSETS_CARD
                      .NO_OF_ASSETS_TO_SHOW,
                }}
                amountOfInformationToShow={InformationAmount.FULL_INFORMATION}
              />
            }
          />
        </div>
      </Card.Body>
    </Card>
  );
};
export default AllYieldBearingAssetsCard;
